// Auth token persistence.
//
// Refresh token is NEVER stored client-side — it lives in an HttpOnly
// cookie set by the backend, immune to XSS.
//
// Access token is held only in module memory (this file) for the duration
// of the tab. On reload, the app calls /login/refresh; the browser sends
// the cookie automatically and gets a fresh access token.

let accessTokenInMemory = null;
const SESSION_EXPIRY_KEY = "vcplsessionexpiry";

export const getAccessToken = () => accessTokenInMemory;

export const setAccessToken = (token) => {
    accessTokenInMemory = token && token !== "NA" ? token : null;
};

// Refresh token is HttpOnly-cookie only — these stubs exist so any
// lingering caller compiles cleanly during the migration.
export const getRefreshToken = () => null;
export const setRefreshToken = () => {};

export const getSessionExpiry = () => localStorage.getItem(SESSION_EXPIRY_KEY);
export const setSessionExpiry = (value) => localStorage.setItem(SESSION_EXPIRY_KEY, value);

export const clearAuth = () => {
    accessTokenInMemory = null;
    localStorage.removeItem(SESSION_EXPIRY_KEY);
    // legacy keys — clean up old localStorage entries left by the previous version
    localStorage.removeItem("vcpltokenrepier");
    localStorage.removeItem("vcplrefreshtoken");
};
